import React from "react";
import { Box, Typography } from "@mui/material";
import WelcomeImage from '../../../assets/images/welcome-image.png';
export default function WelcomeBanner() {
  return (
    <Box
      sx={{
        width: "100%",
        height: '100%',
        position: "relative",

      }}
    >
      {/* Background Image */}
      <Box id="backGroundImage"
        sx={{
          width: "100%",
          height: "100%",
          backgroundImage: `url(${WelcomeImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          top: 0,
          right: 0,
          clipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%, 0 100%)",
        }}
      />
      {/* TOP GREEN TRIANGLE */}
      <Box id="topTriangle"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "60%",
          backgroundColor: "#44BDAA",
          clipPath: "polygon(0% 0%, 43% 0%, 24% 74%)",
        }}
      />
      {/* BOTTOM GREEN TRIANGLE */}
      <Box id="bottomTriangle"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "60%",
          backgroundColor: "#26E882",
          opacity: 0.5,
          clipPath: "polygon(24% 7%, 0 100%, 41% 100%)",
        }}
      />
      {/* Left TRIANGLE */}
      <Box id="leftTriangle"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          clipPath: "polygon(0 0, 0 0, 24% 44.3%, 15% 65%, 0 100%)",
          zIndex: 2
        }}
      />
      {/* Bottom Bar */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          bgcolor: "primary.main",
          py: '1vw',
          px: '1vw',
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          clipPath: "polygon(1.4vw 0, 100% 0, 100% 100%, 0% 100%)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 100,
            color: "#fff",
            mr: 1,
            fontSize: '2.8vw'
          }}
        >
          Hi,
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 600,
            color: "#fff",
            fontSize: '2.8vw'
          }}
        >
          welcome back
        </Typography>
      </Box>
    </Box>
  );
}
